import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";

import "./style.scss";
import { Modal, Spin } from "antd";
import { useAddLesson } from "../../../../../../stores/stores";
import {
  ConnectQuestionData,
  QuestionData,
} from "../../../../../../types/course-construction";
import { ModeQuestion, QuestionTypeEnum } from "../../../../../../constants";
import ChooseText from "../../../../../../components/course-construction/question-item/choose-text";
import ChooseImage from "../../../../../../components/course-construction/question-item/choose-image";
import ChooseVideo from "../../../../../../components/course-construction/question-item/choose-video";
import TrueOrFalse from "../../../../../../components/course-construction/question-item/true-or-false";
import DropDown from "../../../../../../components/course-construction/question-item/drop-down";
import ChooseMultiText from "../../../../../../components/course-construction/question-item/choose-multi-text";
import ChooseMultiImage from "../../../../../../components/course-construction/question-item/choose-multi-image";
import ChooseMultiVideos from "../../../../../../components/course-construction/question-item/choose-multi-video";
import Connect from "../../../../../../components/course-construction/question-item/connect";
import ShortText from "../../../../../../components/course-construction/question-item/short-text";
import FileUpload from "../../../../../../components/course-construction/question-item/file-upload";
import Video from "../../../../../../components/course-construction/question-item/video";
import Mp3 from "../../../../../../components/course-construction/question-item/mp3";
import Calculated from "../../../../../../components/course-construction/question-item/calculated";
import CalculatedMulti from "../../../../../../components/course-construction/question-item/caculated-multi";
import Essay from "../../../../../../components/course-construction/question-item/essay";
import Numerical from "../../../../../../components/course-construction/question-item/numerical";
import { getDetailQuizInBank } from "../../../../../../service/question-bank";
import { isEmpty, toNumber } from "lodash";
import useKeyword from "../../../../../../hooks/useKeyword";
import { useDirty } from "../../../../../../contexts/DirtyProvider";

type ContentProps = {
  setLoadingDetail?: (value: boolean) => void;
};

function Content({ setLoadingDetail }: ContentProps) {
  const { t } = useTranslation();
  const question = useAddLesson((state: any) => state.question);
  const modeQuestion = useAddLesson((state) => state.modeQuestion);
  const setQuestionSettingsBe = useAddLesson(
    (state) => state.setQuestionSettingsBe
  );
  const { setQuestion } = useAddLesson();

  const [loadingQuestion, setLoadingQuestion] = useState<boolean>(false);
  const [questionData, setQuestionData] = useState<QuestionData>();
  const [connectQuestionData, setConnectQuestionData] =
    useState<ConnectQuestionData>();

  const currentQuizEditInBank = toNumber(useKeyword("quizId"));
  const currentQuizVersion = toNumber(useKeyword("version"));

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [draftId, setDraftId] = useState<number>(0);

  const handleOk = () => {
    setIsModalOpen(false);
    getDetailQuestion();
  };

  const handleCancel = () => {
    setDraftId(0);
    setIsModalOpen(false);
  };

  useEffect(() => {
    const initialQuestionEdit = async () => {
      if (currentQuizEditInBank && modeQuestion === ModeQuestion.UPDATE) {
        const dataReq = currentQuizVersion
          ? currentQuizEditInBank
          : question.id || currentQuizEditInBank;
        const quizDetail = await getDetailQuizInBank(dataReq);

        if (quizDetail.data.body?.draftId && draftId === 0) {
          setDraftId(quizDetail.data.body?.draftId);
          setIsModalOpen(true);
        } else {
          setDraftId(0);
        }

        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(quizDetail.data.body);
        } else {
          setQuestionData(quizDetail.data.body);
        }
        setQuestion({
          ...question,
          question: quizDetail.data.body?.question,
          type: quizDetail.data.body?.type,
        });
      }
    };
    initialQuestionEdit();
  }, [currentQuizEditInBank, modeQuestion]);

  useEffect(() => {
    getDetailQuestion();
  }, [question.id]);

  const getDetailQuestion = async () => {
    try {
      if (question.id && modeQuestion === ModeQuestion.UPDATE) {
        setLoadingDetail && setLoadingDetail(true);
        setLoadingQuestion(true);
        const quizId =
          draftId === 0
            ? currentQuizVersion
              ? currentQuizEditInBank
              : question.id || currentQuizEditInBank
            : draftId;
        const quizDetail = await getDetailQuizInBank(quizId);

        // Xử lý khi câu hỏi có bản nháp
        if (quizDetail.data.body?.draftId && draftId === 0) {
          setDraftId(quizDetail.data.body?.draftId);
          setIsModalOpen(true);
          const newQuestion = {
            ...question,
            draftId: quizDetail.data.body?.draftId,
          };
          setQuestion(newQuestion);
        } else {
          setQuestion(quizDetail.data.body);
          setDraftId(0);
        }

        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(quizDetail.data.body);
        } else {
          setQuestionData(quizDetail.data.body);
        }
        setQuestionSettingsBe(quizDetail.data || {});
      } else {
        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(question);
        } else {
          setQuestionData(question);
        }
        setQuestionSettingsBe({});
      }
    } catch (err: any) {
    } finally {
      setLoadingQuestion(false);
      setLoadingDetail && setLoadingDetail(false);
    }
  };

  const renderQuestionByType = () => {
    if (question.type && !isEmpty(questionData || connectQuestionData))
      switch (question.type) {
        case QuestionTypeEnum.CHOOSE_TEXT:
          return <ChooseText dataFromApi={questionData} />;
        case QuestionTypeEnum.CHOOSE_IMAGE:
          return <ChooseImage data={questionData} />;
        case QuestionTypeEnum.CHOOSE_VIDEO:
          return <ChooseVideo data={questionData} />;
        case QuestionTypeEnum.TRUE_OR_FALSE:
          return <TrueOrFalse data={questionData} />;
        case QuestionTypeEnum.DROP_DOWN:
          return <DropDown data={questionData} />;
        case QuestionTypeEnum.CHOOSE_MULTI_TEXT:
          return <ChooseMultiText data={questionData} />;
        case QuestionTypeEnum.CHOOSE_MULTI_IMAGE:
          return <ChooseMultiImage data={questionData} />;
        case QuestionTypeEnum.CHOOSE_MULTI_VIDEO:
          return <ChooseMultiVideos data={questionData} />;
        case QuestionTypeEnum.CONNECT:
          return <Connect dataFromApi={connectQuestionData} />;
        case QuestionTypeEnum.SHORT_TEXT:
          return <ShortText data={questionData} />;
        case QuestionTypeEnum.FILE_UPLOAD:
          return <FileUpload dataFromApi={questionData} />;
        case QuestionTypeEnum.VIDEO:
          return <Video data={questionData} />;
        case QuestionTypeEnum.MP3:
          return <Mp3 data={questionData} />;
        case QuestionTypeEnum.CALCULATED:
          return <Calculated data={questionData} />;
        case QuestionTypeEnum.CALCULATED_SIMPLE:
          return <Calculated data={questionData} />;
        case QuestionTypeEnum.CALCULATED_MULTI:
          return <CalculatedMulti data={questionData} />;
        case QuestionTypeEnum.ESSAY:
          return <Essay data={questionData} />;
        case QuestionTypeEnum.NUMERICAL:
          return <Numerical data={questionData} />;
        default:
          return <></>;
      }
  };

  return (
    <div className="question-content-box">
      <Spin spinning={loadingQuestion}>{renderQuestionByType()}</Spin>
      <Modal
        title={t("Chọn phiên bản chỉnh sửa", "Chọn phiên bản chỉnh sửa")}
        closable
        maskClosable={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t("Tiếp tục", "Tiếp tục")}
        cancelText={t("Không", "Không")}
        className="check-edit-version-modal"
      >
        <p>
          {t("Câu hỏi này đang có bản nháp, bạn có muốn tiếp tục chỉnh sửa không?", "Câu hỏi này đang có bản nháp, bạn có muốn tiếp tục chỉnh sửa không?")}
        </p>
      </Modal>
    </div>
  );
}

export default Content;
